import { gql } from '@apollo/client';
import { QUOTE_CHANGELOG_VIEW_MODEL_FRAGMENT } from './fragments';

export const QUOTE_CHANGELOG_BY_ID = gql`
  query QuoteChangelogById($input: QuoteChangeLogByIdInput!) {
    quote {
      result: quoteChangelogById(input: $input) {
        error
        success
        entity {
          ...QuoteChangelogViewModelFields
        }
      }
    }
  }
  ${QUOTE_CHANGELOG_VIEW_MODEL_FRAGMENT}
`;
